import Routes from "./Routes";
import { Provider } from "react-redux";
import Store from "./redux/Store";
import "react-toastify/dist/ReactToastify.css";
import axios from "./axios";
import SocketContext from "./Context/SocketContext";
import "./assets/scss/Default.scss";
import "./assets/scss/Landing.scss";
import "./assets/scss/Icons.scss";
import useOnlineStatus from "./hooks/useOnlineStatus";
import { useEffect, useState } from "react";
import { appMode } from "./constants/string";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";

ModuleRegistry.registerModules([AllCommunityModule]);

function App() {
  const isOnline = useOnlineStatus();

  useEffect(() => {
    if (appMode === "production") {
      // Prevent right-click context menu
      const disableRightClick = (event) => event.preventDefault();

      // Prevent Ctrl+S (and Cmd+S for Mac)
      const disableSave = (event) => {
        if ((event.ctrlKey || event.metaKey) && event.key === 's') {
          event.preventDefault();
        }
      };

      // Add event listeners
      document.addEventListener("contextmenu", disableRightClick);
      document.addEventListener("keydown", disableSave);

      // Cleanup function
      return () => {
        document.removeEventListener("contextmenu", disableRightClick);
        document.removeEventListener("keydown", disableSave);
      };
    }
  }, []);

  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);

  useEffect(() => {
    if (appMode === "production") {
      const checkDevTools = () => {
        const threshold = 160; // Approx height of DevTools in most browsers
        if (
          window.outerHeight - window.innerHeight > threshold ||
          window.outerWidth - window.innerWidth > threshold
        ) {
          setIsDevToolsOpen(true);
        } else {
          setIsDevToolsOpen(false);
        }
      };

      const interval = setInterval(checkDevTools, 500);

      return () => clearInterval(interval);
    }
  }, []);

  if (isDevToolsOpen) {
    return <div style={{ textAlign: "center", padding: "50px" }}>🔒 Content Hidden!</div>;
  }

  return (
    <Provider store={Store}>
      <SocketContext>
        <Routes />
      </SocketContext>
    </Provider>
  );
}

export default App;
